/**
 * TptAI Product Comparison Section JavaScript
 * Initializes custom functionality beyond the core Swiper slider
 */

(function() {
  'use strict';
  
  class TptAiProductComparison {
    constructor() {
      this.init();
    }
    
    init() {
      // Add event listeners after DOM is loaded
      document.addEventListener('DOMContentLoaded', () => {
        this.initializeEventListeners();
      });
    }
    
    initializeEventListeners() {
      // If we need to add any special event handlers beyond
      // what the tpt-slider component provides
      
      // Align specification rows across all products
      this.alignSpecificationRows();
      
      // Handle window resize for responsive adjustments
      window.addEventListener('resize', this.debounce(() => {
        this.alignSpecificationRows();
      }, 250));
    }
    
    // Ensure all specification rows have equal heights across products
    alignSpecificationRows() {
      const categories = [];
      const specRows = document.querySelectorAll('.tptai-product-comparison_spec-row');
      
      // Collect all categories
      specRows.forEach(row => {
        const category = row.getAttribute('data-category');
        if (category && !categories.includes(category)) {
          categories.push(category);
        }
      });
      
      // Reset heights first
      specRows.forEach(row => {
        row.style.height = 'auto';
      });
      
      // Set equal heights for each category
      categories.forEach(category => {
        const categoryRows = document.querySelectorAll(`.tptai-product-comparison_spec-row[data-category="${category}"]`);
        if (categoryRows.length > 1) {
          let maxHeight = 0;
          
          // Find maximum height
          categoryRows.forEach(row => {
            const height = row.offsetHeight;
            maxHeight = Math.max(maxHeight, height);
          });
          
          // Apply maximum height to all rows in this category
          if (maxHeight > 0) {
            categoryRows.forEach(row => {
              row.style.height = `${maxHeight}px`;
            });
          }
        }
      });
    }
    
    // Utility function to debounce function calls
    debounce(func, delay) {
      let debounceTimer;
      return function() {
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(context, args), delay);
      };
    }
  }
  
  // Initialize the component
  new TptAiProductComparison();
})();